import { render } from "./GoogleAdSense.vue?vue&type=template&id=0c8eb9a1"
import script from "./GoogleAdSense.vue?vue&type=script&lang=js"
export * from "./GoogleAdSense.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__